import React from 'react';
import PropTypes from 'prop-types';
import { useField } from 'formik';

import { FieldError } from './FieldError';

export const Toggle = ({ label, name, toggleClickHandler, initialValue, labelOnLeft }) => {
    const [isChecked, setIsChecked] = React.useState(initialValue);
    const clickHandler = () => {
        toggleClickHandler(!isChecked);
        setIsChecked(!isChecked);
    };

    return (
        <div className={`toggle-container${labelOnLeft ? ' forward' : ''}`}>
            <div className="toggle-control__label" style={{'maxWidth': '100%'}}>{label}</div>
            <div
                role="none"
                className={`toggle-control toggle-control--${isChecked ? 'on' : 'off'}`}
                onClick={clickHandler}
            >
                <input
                    type="checkbox"
                    name={name}
                    aria-label={label}
                    className="toggle-control__input"
                    value={isChecked}
                />
                <div className={`toggle-control__text toggle-control__text--${isChecked ? 'on' : 'off'}`}>
                    {isChecked ? 'yes' : 'no'}
                </div>
            </div>
        </div>
    );
};

Toggle.defaultProps = {
    name: 'toggle',
    toggleClickHandler: () => {},
    initialValue: false,
    labelOnLeft: true
};

Toggle.propTypes = {
    name: PropTypes.string,
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.array]).isRequired,
    toggleClickHandler: PropTypes.func,
    initialValue: PropTypes.bool,
    labelOnLeft: PropTypes.bool
};

export const ToggleField = props => {
    
    const [field, meta] = useField({ name: props.name, type: 'checkbox' });
    const toggleProps = { ...props, initialValue: meta.value };
    return (
        <React.Fragment>
            <Toggle {...toggleProps} />
            {meta.touched && meta.error && <FieldError message={meta.error} />}
        </React.Fragment>
    );
};

ToggleField.defaultProps = {
    name: 'toggle'
};

ToggleField.propTypes = {
    name: PropTypes.string
};
